import { render, staticRenderFns } from "./PhoneVerificationDialog.vue?vue&type=template&id=20bb0c8e&scoped=true"
import script from "./PhoneVerificationDialog.vue?vue&type=script&lang=js"
export * from "./PhoneVerificationDialog.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerificationDialog.vue?vue&type=style&index=0&id=20bb0c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb0c8e",
  null
  
)

export default component.exports